import React from 'react';
export function RewardBadge({
  chance,
  guaranteed
}: {
  chance?: number;
  guaranteed?: boolean;
}) {
  if (guaranteed) {
    return <span className="inline-flex shrink-0 items-center rounded-full bg-[#D4AF37]/15 px-2.5 py-0.5 text-xs font-bold text-[#D4AF37] whitespace-nowrap" data-id="element-380" data-mp="1fw8wdf8kq9q6">Garantizado</span>;
  }
  if (chance !== undefined) {
    return <span className="inline-flex shrink-0 items-center rounded-full bg-[#4A9EFF]/15 px-2.5 py-0.5 text-xs font-bold text-[#4A9EFF] whitespace-nowrap tabular-nums" data-id="element-381" data-mp="1prk43dlkegof">{chance}% de probabilidad</span>;
  }
  return null;
}